// extracted by mini-css-extract-plugin
export default {"root":"GroupsPage_root__K+J3i","logo":"GroupsPage_logo__HVClA","title":"GroupsPage_title__rOcS9","content":"GroupsPage_content__7UrIS"};